import { render, staticRenderFns } from "./AnaMarques.vue?vue&type=template&id=625fffbe&scoped=true"
import script from "./AnaMarques.vue?vue&type=script&lang=js"
export * from "./AnaMarques.vue?vue&type=script&lang=js"
import style0 from "./AnaMarques.vue?vue&type=style&index=0&id=625fffbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625fffbe",
  null
  
)

export default component.exports